export default __webpack_public_path__ + "static/media/bedroomGood.ce791f50.png";